window.ErrorHandlerMixin = require('../components/mixins/ErrorHandlerMixin.js').default;
window.APIFormatterMixin = require('../components/mixins/APIFormatterMixin.js').default;

moment.tz.setDefault('America/Phoenix');

Vue.component('user-app-course-schedule-details', require('./components/CourseScheduleDetailsComponent').default);
Vue.component('user-app-course-orders-calendar', require('./components/CourseOrdersCalendarComponent').default);
Vue.component('user-app-course-schedule-row', require('./components/CourseScheduleRowComponent').default);
Vue.component('user-app-course-schedule-list', require('./components/CourseSchedulesListComponent').default);

